import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createBadgeListBlock,
  createButtonBlock,
  createH1Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";
import { defaultData as UserSatisfactionBlockDefaultData } from "../../Sections/UserSatisfactionBlock/UserSatisfactionDefaultData";
import { getSalesBlockPrimaryStyleOptions } from "../constants";
import imagePlaceholder from "./homepage_block_1_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock1",
  props: {
    badges: {
      prop: "children",
      type: "children",
      value: [
        createBadgeListBlock({
          items: ["Transform Your Life Today"],
        }),
      ],
    },
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createH1Block({
          text: "Unlock Your Full Potential with Expert Coaching",
        }),
        createPBlock({
          text: "Join thousands who have transformed their careers, relationships, and personal growth with our proven coaching methodology.",
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: imagePlaceholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxWidth: "none",
                maxHeight: "none",
                width: "100%",
                height: "100%",
                minWidth: "none",
                minHeight: "none",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    buttons: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "Book Your Free Session",
          href: "#",
        }),
        createButtonBlock({
          text: "Join the Community",
          buttonType: "secondaryButton",
          href: "#",
        }),
      ],
    },
    userSatisfaction: {
      prop: "children",
      type: "children",
      value: [
        {
          ...UserSatisfactionBlockDefaultData,
        },
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockPrimaryStyleOptions(),
      },
    },
  },
};
